import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectHomeScheduleExceptions } from "../../redux/selector";
import { useStyles } from "./styles";

const fallbackRows = [
  {
    id: 1,
    source: "WO-5501",
    statusKey: "HOME.STATUS.ENGINEERING",
    statusColor: "#9B59B6",
    statusTime: "5",
    exception: "3",
  },
  {
    id: 2,
    source: "WO-5502",
    statusKey: "HOME.STATUS.PRODUCTION",
    statusColor: "#F39C12",
    statusTime: "5",
    exception: "8",
  },
  {
    id: 3,
    source: "WO-5503",
    statusKey: "HOME.STATUS.IN_PRODUCTION",
    statusColor: "#95A5A6",
    statusTime: "3",
    exception: "5",
  },
  {
    id: 4,
    source: "WO-5501",
    statusKey: "HOME.STATUS.ENGINEERING",
    statusColor: "#9B59B6",
    statusTime: "5",
    exception: "3",
  },
  {
    id: 5,
    source: "WO-5502",
    statusKey: "HOME.STATUS.PRODUCTION",
    statusColor: "#F39C12",
    statusTime: "5",
    exception: "8",
  },
  {
    id: 6,
    source: "WO-5503",
    statusKey: "HOME.STATUS.IN_PRODUCTION",
    statusColor: "#95A5A6",
    statusTime: "3",
    exception: "5",
  },
  {
    id: 7,
    source: "WO-5501",
    statusKey: "HOME.STATUS.ENGINEERING",
    statusColor: "#9B59B6",
    statusTime: "5",
    exception: "3",
  },
  {
    id: 8,
    source: "WO-5502",
    statusKey: "HOME.STATUS.PRODUCTION",
    statusColor: "#F39C12",
    statusTime: "5",
    exception: "8",
  },
];

const ScheduleExceptions = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const reduxRows = useSelector(selectHomeScheduleExceptions);

  const rows = reduxRows && reduxRows.length > 0 ? reduxRows : fallbackRows;

  const getDaysText = (value: string | number) => {
    return `${value} ${t("HOME.DAYS")}`;
  };

  return (
    <Box className={styles.card}>
      <Typography className={styles.title}>
        {t("HOME.SCHEDULE_EXCEPTIONS")}
      </Typography>

      <Box className={styles.tableHeader}>
        <Typography>{t("HOME.SOURCE")}</Typography>
        <Typography>{t("HOME.STATUS_TEXT")}</Typography>
        <Typography>{t("HOME.TIME_IN_STATUS")}</Typography>
        <Typography>{t("HOME.EXCEPTION")}</Typography>
      </Box>

      <Box className={styles.tableBody}>
        {rows.map((row, index) => (
          <Box key={`${row.source}-${index}`} className={styles.tableRow}>
            <Typography className={styles.link}>{row.source}</Typography>

            <Box>
              <Typography
                className={styles.statusBadge}
                style={{ backgroundColor: row.statusColor }}
              >
                {t(row.statusKey)}
              </Typography>
            </Box>

            <Typography
              className={
                Number(row.statusTime) === 5 ? styles.dangerText : styles.text
              }
            >
              {getDaysText(row.statusTime)}
            </Typography>

            <Typography className={styles.text}>
              {getDaysText(row.exception)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ScheduleExceptions;